import React from 'react';
import { TIAN_GAN, DI_ZHI } from '../utils/baziData';
import { ElementBadge } from '../components/ElementBadge';
import { InteractiveQuiz } from '../components/InteractiveQuiz';
import { Lightbulb } from 'lucide-react';
export const TianGanDiZhi: React.FC = () => {
  const quizQuestions = [{
    question: '天干中属于阳木的是哪一个？',
    options: ['甲', '乙', '丙', '丁'],
    correctAnswer: 0,
    explanation: '甲为阳木，代表参天大树；乙为阴木，代表花草藤蔓。'
  }, {
    question: "地支'子'对应的生肖和五行是？",
    options: ['牛/土', '鼠/水', '猪/水', '兔/木'],
    correctAnswer: 1,
    explanation: '子对应生肖鼠，五行属水，是一天中23:00-01:00的时辰。'
  }];
  return <div className="space-y-12" data-id="element-367">
      <div className="text-center mb-10" data-id="element-368">
        <h1 className="text-3xl font-serif font-bold text-gold-dark mb-4" data-id="element-369">
          天干地支
        </h1>
        <p className="text-ink-light" data-id="element-370">
          八字命理的字母表，构成宇宙万物的基础符号。
        </p>
      </div>

      {/* Memory Aid Section */}
      <div className="bg-gold/5 border border-gold/20 p-6 rounded-lg flex gap-4 items-start" data-id="element-371">
        <div className="bg-gold/20 p-2 rounded-full text-gold-dark shrink-0" data-id="element-372">
          <Lightbulb size={24} data-id="element-373" />
        </div>
        <div data-id="element-374">
          <h3 className="font-serif font-bold text-gold-dark text-lg mb-2" data-id="element-375">
            小白记忆法：联想记忆
          </h3>
          <p className="text-ink-light text-sm leading-relaxed" data-id="element-376">
            不要死记硬背！把天干想象成大自然中的事物：
            <br data-id="element-377" />
            <strong data-id="element-378">甲乙木：</strong>甲是参天大树(阳)，乙是花草藤蔓(阴)。
            <br data-id="element-379" />
            <strong data-id="element-380">丙丁火：</strong>丙是太阳之火(阳)，丁是灯烛之火(阴)。
            <br data-id="element-381" />
            <strong data-id="element-382">戊己土：</strong>戊是高山岩石(阳)，己是田园泥土(阴)。
            <br data-id="element-383" />
            <strong data-id="element-384">庚辛金：</strong>庚是刀剑矿石(阳)，辛是珠宝首饰(阴)。
            <br data-id="element-385" />
            <strong data-id="element-386">壬癸水：</strong>壬是江河大海(阳)，癸是雨露之水(阴)。
          </p>
        </div>
      </div>

      <section className="space-y-6" data-id="element-387">
        <h2 className="text-2xl font-serif text-gold-dark border-l-4 border-gold pl-3" data-id="element-388">
          十天干
        </h2>
        <p className="text-ink-light leading-relaxed" data-id="element-389">
          天干代表天上的气场，主外在、显露、主动。共有十个，分阴阳五行。
        </p>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4" data-id="element-390">
          {TIAN_GAN.map((stem, idx) => <div key={idx} className="bg-white ink-border p-4 rounded-lg flex flex-col items-center text-center card-hover shadow-sm" data-id="element-391">
              <ElementBadge char={stem.name} element={stem.element} size="lg" className="mb-3" data-id="element-392" />
              <div className="text-xs text-ink-light mb-2 font-medium bg-paper px-2 py-1 rounded" data-id="element-393">
                {stem.yinYang === 'yang' ? '阳' : '阴'}
                {stem.element === 'wood' ? '木' : stem.element === 'fire' ? '火' : stem.element === 'earth' ? '土' : stem.element === 'metal' ? '金' : '水'}
              </div>
              <div className="text-xs text-ink-light/80" data-id="element-394">{stem.meaning}</div>
            </div>)}
        </div>
      </section>

      <section className="space-y-6" data-id="element-395">
        <h2 className="text-2xl font-serif text-gold-dark border-l-4 border-gold pl-3" data-id="element-396">
          十二地支
        </h2>
        <p className="text-ink-light leading-relaxed" data-id="element-397">
          地支代表地上的气场，主内在、隐藏、被动。对应十二生肖与十二时辰。
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4" data-id="element-398">
          {DI_ZHI.map((branch, idx) => <div key={idx} className="bg-white ink-border p-4 rounded-lg flex flex-col items-center text-center card-hover shadow-sm" data-id="element-399">
              <ElementBadge char={branch.name} element={branch.element} size="lg" className="mb-3" data-id="element-400" />
              <div className="font-bold text-ink mb-1" data-id="element-401">{branch.animal}</div>
              <div className="text-xs text-ink-light mb-1 font-medium" data-id="element-402">
                {branch.yinYang === 'yang' ? '阳' : '阴'}
                {branch.element === 'wood' ? '木' : branch.element === 'fire' ? '火' : branch.element === 'earth' ? '土' : branch.element === 'metal' ? '金' : '水'}
              </div>
              <div className="text-xs text-gold-dark/80 bg-gold/5 px-2 py-0.5 rounded mt-1" data-id="element-403">
                {branch.time}
              </div>
            </div>)}
        </div>
      </section>

      <section className="mt-16" data-id="element-404">
        <InteractiveQuiz questions={quizQuestions} data-id="element-405" />
      </section>
    </div>;
};